import { defineComponent as _defineComponent } from 'vue'
import { handleDragging, startDragging, stopDragging } from "@/helpers/zoom";
  import { ref } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderLightboxImages',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    zoom: {
      type: Number,
      required: true,
    },
  },
  emits: ["close", "updateZoom"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const closeModal = () => {
    emits("close");
  };

  const isDragging = ref(false);
  const svgStartPosition = ref({ x: 0, y: 0 });
  const svgStartScrollPosition = ref({ x: 0, y: 0 });
  const svgContainerMap = ref();

  const startDrag = (event: MouseEvent) => {
    startDragging(
      event,
      props.zoom,
      isDragging,
      svgContainerMap,
      svgStartPosition,
      svgStartScrollPosition
    );
  };
  const handleDrag = (event: MouseEvent) => {
    handleDragging(
      event,
      isDragging,
      svgContainerMap,
      svgStartPosition,
      svgStartScrollPosition
    );
  };
  const stopDrag = () => {
    stopDragging(props.zoom, isDragging, svgContainerMap);
  };

const __returned__ = { props, emits, closeModal, isDragging, svgStartPosition, svgStartScrollPosition, svgContainerMap, startDrag, handleDrag, stopDrag, get handleDragging() { return handleDragging }, get startDragging() { return startDragging }, get stopDragging() { return stopDragging }, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})